export default "https://cdn-static.gokick.com/assets/16eea26e4b02b6fb7531e57480884e04972270e8/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";